module.exports = __webpack_public_path__ + "img/redpack.0af92b2d.png";